import React from 'react';
import { Badge } from '@mui/material';
import { makeStyles } from '@mui/styles';
import styles from './Button.module.scss';
import AsStandInLabel from '../AsStandInLabel/AsStandInLabel';

const badgeStyle = makeStyles(() => ({
  badge: {
    margin: '0 0 0 10px',
  },
}));

interface BadgeI {
  isNotification: false,
  badge: number,
}

interface ButtonI {
  handleClick?: () => any;
  buttonStyle?: string;
  btnText?: string;
  btnIco?: string;
  disabled?: boolean;
  active?: boolean;
  id?: string;
  dot?: string;
  showBadge?: boolean | BadgeI;
  asStandIn?: boolean;
  extraButtonClasses?: string;
}

const Button: React.FC<ButtonI> = ({ handleClick = () => { }, buttonStyle = 'TableButton', btnText = '', btnIco = '',
  disabled = false, active = false, id = '', dot = '', showBadge = false, asStandIn, extraButtonClasses, ...props }) => {
  const buttonClasses = `${styles[buttonStyle] || styles.Primary} ${active ? styles.Active : ''} ${extraButtonClasses || ''}`;
  const badgeClasses = badgeStyle();

  const badge = typeof showBadge === 'boolean' ? 0 : showBadge.badge;

  return (
    <button
      key={id}
      id={id}
      data-testid={id}
      type="button"
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {btnIco ? <i className={`${btnIco} ${styles.Icon}`} /> : ''}
      {btnText}
      {dot && <span className={styles[dot]}>&#8226;</span>}
      {showBadge && (
        <div className={styles.BadgeWrapper}>
          <Badge classes={badgeClasses} badgeContent={badge} color="primary" overlap="rectangular" />
        </div>
      )}
      {(asStandIn && !disabled) && (<AsStandInLabel actionButton />)}
    </button>
  );
};

export default Button;
